// The public-facing version that is shown in the About Trqk modal and used in marketing / promotion
export const PUBLIC_VERSION = '7.1.3';

export const MAIN_CONTENT_ID = 'main-content';

export const PATHS = {
    CLIENT_EVENTS: '/client-events',
    CONFIRM_PASSWORD_RESET: '/confirm-password-reset',
    CONTACT: 'https://www.trqk.io/',
    CONTROL_PANEL: '/control-panel',
    DETAIL: '/detail',
    DETECTIONS: '/detections',
    FORGOT_PASSWORD: '/forgot-password',
    GAP_ANALYSIS: '/gap-analysis',
    HELP: '/help',
    INSIGHTS: '/insights',
    LANDING: '/',
    NOT_FOUND: '/not-found',
    REPORTS: '/reports',
    SETTINGS: '/settings',
    SIGN_IN: '/sign-in',
    SIGN_UP: '/sign-up',
    STATEMENTS: '/statements',
    STATEMENTS_PREVIEW: '/statements-preview',
    TEST_HARNESS: '/test-harness',
    TRYOUT: '/tryout',
    VERIFY_ACCOUNT: '/verify-account',
    WORKS: '/works',
};

export const PAYWALL_PATHS = [
    PATHS.CLIENT_EVENTS,
    PATHS.CONTROL_PANEL,
    PATHS.DETAIL,
    PATHS.DETECTIONS,
    PATHS.GAP_ANALYSIS,
    PATHS.INSIGHTS,
    PATHS.REPORTS,
    PATHS.STATEMENTS,
    PATHS.WORKS,
];

export const CHILD_PATHS = {
    DETECTIONS: {
        MANAGE: '/manage',
    },
    STATEMENTS: {
        CHARTS: '/charts',
        MANAGE: '/manage',
        TABLE: '/table',
    },
    GAP_ANALYSIS: {
        MANAGE: '/manage',
        VIEW: '/view',
    },
};

export const HASHES = {
    MANAGE_DETECTIONS: {
        ALERTS: '#alerts',
        DETECTION_SETTINGS: '#detection-settings',
        UPLOADS: '#uploads',
    },
    MANAGE_STATEMENTS: {
        ALERTS: '#alerts',
        COMPLETE: '#complete',
        UPLOADS: '#uploads',
    },
    SETTINGS: {
        ENTITY_MANAGER: '#entity-manager',
        INVITE_OTHERS: '#invite-others',
        NOTIFICATIONS: '#notifications',
        PAYMENT_PLAN: '#payment-plan',
        PROFILE: '#profile',
    },
    STATEMENTS: {
        BREAKDOWN: '#breakdown',
        EARNINGS_AND_RANGES: '#earnings-and-ranges',
        EXPLORER: '#explorer',
        REGIONS: '#regions',
    },
    REPORTS: {
        TOTAL_ROYALTIES: '#total-royalties',
    },
};

export const FULL_PATHS = {
    MANAGE_GAP_ANALYSIS: `${PATHS.GAP_ANALYSIS}${CHILD_PATHS.GAP_ANALYSIS.MANAGE}`,
    VIEW_GAP_ANALYSIS: `${PATHS.GAP_ANALYSIS}${CHILD_PATHS.GAP_ANALYSIS.VIEW}`,
    MANAGE_DETECTIONS: `${PATHS.DETECTIONS}${CHILD_PATHS.DETECTIONS.MANAGE}`,
    MANAGE_STATEMENTS_CHARTS: `${PATHS.STATEMENTS}${CHILD_PATHS.STATEMENTS.CHARTS}${CHILD_PATHS.STATEMENTS.MANAGE}`,
    MANAGE_STATEMENTS_TABLE: `${PATHS.STATEMENTS}${CHILD_PATHS.STATEMENTS.TABLE}${CHILD_PATHS.STATEMENTS.MANAGE}`,
    PAYOUT_RANGES: `${PATHS.STATEMENTS}${HASHES.STATEMENTS.EARNINGS_AND_RANGES}`,
    STATEMENTS_CHARTS: `${PATHS.STATEMENTS}${CHILD_PATHS.STATEMENTS.CHARTS}`,
    STATEMENTS_TABLE: `${PATHS.STATEMENTS}${CHILD_PATHS.STATEMENTS.TABLE}`,
};

export const EXTERNAL_REDIRECTS = {
    PAYMENT_PLAN: `${PATHS.SETTINGS}${HASHES.SETTINGS.PAYMENT_PLAN}`,
};

export const PUBLIC_PATHS = [
    PATHS.CONFIRM_PASSWORD_RESET,
    PATHS.FORGOT_PASSWORD,
    PATHS.LANDING,
    PATHS.SIGN_IN,
    PATHS.SIGN_UP,
    PATHS.STATEMENTS_PREVIEW,
    PATHS.TRYOUT,
    PATHS.VERIFY_ACCOUNT,
];

export const URL_PARAMS = {
    AUDIO_ID: 'audio_id',
    CHANNEL: 'channel',
    COMPANY: 'company',
    COUNTRY: 'country',
    CONFIDENCE: 'confidence',
    CONFIRMED_EMAIL: 'confirmed_email',
    CONTINUE_MANAGE_GAP_ANALYSIS: 'continue_create_gap_analysis',
    DATE_END: 'date_end',
    DATE_LABEL: 'date_label',
    DATE_START: 'date_start',
    DAY_PART: 'day_part',
    DETAIL_STATEMENT_IDS: 'detail_statement_ids',
    DETAIL_STATEMENT_PRESET_FALLBACK: 'detail_statement_preset_fallback',
    DETAIL_STATEMENT_PRESET_PRIMARY: 'detail_statement_preset_primary',
    DURATION_GREATER_THAN: 'duration_greater_than',
    EMAIL: 'email',
    ENTITY_ID: 'entity_id',
    EPISODE: 'episode',
    FILENAME: 'filename',
    FIRST_NAME: 'first_name',
    GAP_ANALYSIS_ID: 'gap_analysis_id',
    GAP_ANALYSIS_MODE: 'gap_analysis_mode',
    LAST_NAME: 'last_name',
    MAX_EARNINGS: 'max_earnings',
    MEDIA: 'media',
    MIN_EARNINGS: 'min_earnings',
    PAYMENT_TYPE: 'payment_type',
    PROGRAM_PRODUCTION_COMPANY: 'program_production_company',
    PROGRAM: 'program',
    PUBLISHER: 'publisher',
    REDIRECT_TO: 'redirect_to',
    SHOW: 'show',
    SONG_ID: 'song_id',
    STATEMENT_ID: 'statement_id',
    STATEMENT_IDS: 'statement_ids',
    STATEMENT_PRESET_FALLBACK: 'statement_preset_fallback',
    STATEMENT_PRESET_PRIMARY: 'statement_preset_primary',
    STATION: 'station',
    TERRITORY: 'territory',
    TITLE: 'title',
    TOKEN_MISSING: 'token_missing',
    USER_ALREADY_EXISTS: 'user_already_exists',
    WORK_TITLE: 'work_title',
    WRITER: 'writer',
};

export const INSIGHTS_TOUR_CARD_IDS = {
    welcome: 'tour-card-welcome',
    step1: 'tour-card-step-1',
    step2: 'tour-card-step-2',
    step3: 'tour-card-step-3',
    step4: 'tour-card-step-4',
    step5: 'tour-card-step-5',
    step6: 'tour-card-step-6',
};

export const INSIGHTS_TOUR_CARD_DONE = 'done';

export const TASK_GROUP_ID_STATEMENT_UPLOADS = 'task-group-statement-uploads';

export const TASK_GROUP_ID_AUDIO_UPLOADS = 'task-group-audio-uploads';

export const TASK_GROUP_ID_DETECTION_UPLOADS = 'task-group-detection-uploads';

export const ANCHOR_SCROLL_DELAY = 3000;

export const ANCHOR_LINK_RULES: AnchorLocationRule[] = [
    {
        pathname: FULL_PATHS.STATEMENTS_CHARTS,
        type: 'status',
    },
    {
        pathname: PATHS.REPORTS,
        type: 'status',
    },
];

export const LOCAL_STORAGE_KEYS = {
    SCRIPT_BLOCKER_FLAGS: 'scriptBlockerFlags',
};

export const MODAL_IDS = {
    MANAGE_GAP_ANALYSIS: 'manage-gap-analysis',
    VIEW_GAP_ANALYSIS: 'view-gap-analysis',
};
